"use strict";

import ModalQueue from './modal-queue.js';
var modalQueue = new ModalQueue();

import Popup from './news/popup.js';
import Links from './news/links.js';

require( './gamification/index' );
require( './modules/index' );
require( './statistic/index' );
require( './content-modules/index' );
require( './navigation/index' );
require( './layout/index' );

iPortalCore.newsPopup = new Popup( modalQueue );
new Links( iPortalCore.newsPopup );

import Rating from './comments/rating.js';
const elements = document.querySelectorAll( '.comment-rating' );
for ( const element of elements ) {
	new Rating( element );
}

import PointOutError from './comments/point-out-error.js';
import MarkHighQuality from './comments/mark-high-quality.js';
const comments = document.querySelectorAll( '.comment-list .comment' );
for ( const comment of comments ) {
	new PointOutError( comment );
	new MarkHighQuality( comment );
}

import Folding from './comments/folding.js';
new Folding();

jQuery('[data-toggle="tooltip"]').tooltip();
